module.exports = __webpack_public_path__ + "static/media/paymentsuccessbusiness.6f15fe7e.png";